export const VEHICLE_ACTIONS = {
  OPEN_VEHICLE: 'open-vehicle',
  CLOSE_VEHICLE: 'close-vehicle',
  SET_VEHICLE_INFO: 'set-vehicle-info',
}